module.exports = __webpack_public_path__ + "assets/webgl/art_052_L0.jpg.etc.c5d066d0.ktx";